module.exports = __webpack_public_path__ + "static/media/ser_div_off.16d4753b.png";